// @ts-nocheck
(function () {
  if (window.__sonnoPdpVariantSelectorLoaded) {
    return;
  }
  window.__sonnoPdpVariantSelectorLoaded = true;

  // console.log('PDP Variant selector script loading...');

  // Shopify Storefront API configuration
  const STOREFRONT_API_TOKEN = '31d32250d5f86128fb0b5fae52757438';
  const SHOP_URL = 'https://direct-cheap-beds.myshopify.com';
  const API_VERSION = '2024-10';

  // Initialize state management
  window.pdpState = window.pdpState || {
    colour: 'Loading...',
    size: 'Small Single 2FT6',
    storage: 'No Storage',
    headboard: 'FREE 26" Headboard',
    headboardButton: '',
    base: 'Standard Base',
    baseKey: 'standard',
    sizePrice: 0,
    storagePrice: 0,
    headboardPrice: 0,
    basePrice: 0,
    currentProductHandle: null
  };

  // Helper function to extract price from text
  function extractPrice(text) {
    const match = text.match(/£?([\d,]+\.?\d*)/);
    return match ? parseFloat(match[1].replace(',', '')) : 0;
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeKey(value) {
    // Aggressive key normalization for matching option values across products
    return normalizeText(value).replace(/[^a-z0-9]+/g, '');
  }

  function decodeHtmlEntities(value) {
    const str = String(value || '');
    if (!str.includes('&')) return str;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  }

  function isNoColourMobile() {
    try {
      return Boolean(window.matchMedia && window.matchMedia('(max-width: 650px)').matches);
    } catch (_e) {
      return false;
    }
  }

  // Helper function to update prices
  function updatePricing() {
    if (window.pdpPricing && typeof window.pdpPricing.updatePrice === 'function') {
      window.pdpPricing.updatePrice();
    }
    // Also update the price block display
    if (window.pdpState?._lastVariant) {
      updatePriceBlockFromVariant(window.pdpState._lastVariant);
    } else {
      updatePriceBlock();
    }
  }

  // Helper function to find current variant based on selected options
  function findCurrentVariant(productData) {
    if (!productData || !productData.variants) return null;

    const selectedOptions = {
      size: window.pdpState.size,
      storage: window.pdpState.storage,
      headboard: window.pdpState.headboard
    };

    // Find variant matching all selected options
    return productData.variants.find(variant => {
      let matches = true;
      productData.options.forEach((option, index) => {
        const optionName = option.name.toLowerCase();
        const variantValue = variant[`option${index + 1}`];

        if (optionName === 'size' && variantValue !== selectedOptions.size) matches = false;
        if (optionName === 'storage' && variantValue !== selectedOptions.storage) matches = false;
        if (optionName === 'headboard' && variantValue !== selectedOptions.headboard) matches = false;
      });
      return matches;
    });
  }

  // Helper function to update URL with variant ID
  function updateVariantURL(variantId, productHandle) {
    if (!variantId) return;

    const handleFromState = window.pdpState && (window.pdpState.currentProductHandle || window.pdpState.productHandle);
    const handle = productHandle || handleFromState;

    const url = new URL(window.location.href);
    if (handle) {
      url.pathname = `/products/${handle}`;
      try {
        window.pdpState = window.pdpState || {};
        window.pdpState.currentProductHandle = handle;
        window.pdpState.productHandle = handle;
      } catch (_e) { }
    }
    url.searchParams.set('variant', String(variantId));

    window.history.replaceState({ variantId, productHandle: handle || null }, '', url.toString());
    // console.log('URL updated to:', url.toString());
  }

  function getCurrentHandle() {
    try {
      const fromState = window.pdpState && (window.pdpState.currentProductHandle || window.pdpState.productHandle);
      if (fromState) return String(fromState);
    } catch (_e) { }

    try {
      const grid = document.querySelector('#colorProductsGrid');
      const fromDom = grid && grid.getAttribute && grid.getAttribute('data-current-handle');
      if (fromDom) return String(fromDom);
    } catch (_e) { }

    try {
      const m = String(window.location.pathname || '').match(/\/products\/([^/?#]+)/);
      if (m && m[1]) return m[1];
    } catch (_e) { }

    return null;
  }

  // Helper function to update filter bar option prices
  function updateFilterBarPrice(filterType, priceText, show = true) {
    const filterItems = document.querySelectorAll(`[data-filter="${filterType}"]`);
    filterItems.forEach(item => {
      const priceEl = item.querySelector('.option-price');
      if (priceEl) {
        if (show && priceText) {
          priceEl.textContent = priceText;
          priceEl.style.display = 'block';
        } else {
          priceEl.style.display = 'none';
        }
      }
    });
  }

  function getHeadboardFilterText(headboardValue) {
    const headboardText = String(headboardValue || '').trim();
    const buttonText = String(window.pdpState?.headboardButton || '').trim();
    if (headboardText && buttonText) return `${headboardText} & ${buttonText}`;
    return headboardText || buttonText;
  }

  function setHeadboardFilterText(headboardValue) {
    const text = getHeadboardFilterText(headboardValue);
    document.querySelectorAll('[data-filter="headboard"] .filter-value').forEach((el) => {
      el.textContent = text;
    });
  }

  function formatFilterBarDiff(centsDiff) {
    const diff = centsDiff / 100;
    if (!Number.isFinite(diff) || diff === 0) return '';
    const sign = diff > 0 ? '+' : '';
    return `(${sign}£${diff.toFixed(2)})`;
  }

  function getCheapestVariant(variants) {
    if (!Array.isArray(variants) || variants.length === 0) return null;
    return variants.reduce((min, v) => (v.price < min.price ? v : min), variants[0]);
  }

  function getMinVariantPrice(variants, predicate) {
    if (!Array.isArray(variants) || variants.length === 0) return null;
    let min = null;
    for (const v of variants) {
      if (!predicate(v)) continue;
      if (typeof v.price !== 'number') continue;
      if (min === null || v.price < min) min = v.price;
    }
    return min;
  }

  function getBaselineVariantForFilter(productData, filterType) {
    if (!productData?.variants) return null;

    const size = window.pdpState?.size;
    const storage = window.pdpState?.storage;
    const headboard = window.pdpState?.headboard;

    let candidates = productData.variants;
    if (filterType === 'size') {
      candidates = candidates.filter(v => v.option2 === storage && v.option3 === headboard);
    } else if (filterType === 'storage') {
      candidates = candidates.filter(v => v.option1 === size && v.option3 === headboard);
    } else if (filterType === 'headboard') {
      candidates = candidates.filter(v => v.option1 === size && v.option2 === storage);
    } else {
      return null;
    }

    return getCheapestVariant(candidates);
  }

  function updatePriceBlockFromVariant(variant) {
    const priceBlock = document.querySelector('.price-details');
    if (!priceBlock || !variant) return;

    const baseAddonPounds = parseFloat(window.pdpState?.basePrice || 0) || 0;
    const baseAddonCents = Math.round(baseAddonPounds * 100);

    const mattressAddonPounds = parseFloat(window.pdpState?.mattressAddonPrice || 0) || 0;
    const mattressAddonCents = Math.round(mattressAddonPounds * 100);
    const mattressAddonComparePounds = parseFloat(window.pdpState?.mattressAddonCompareAt || 0) || 0;
    const mattressAddonCompareCents = Math.round(mattressAddonComparePounds * 100);

    const assemblyAddonPounds = parseFloat(window.pdpState?.assemblyAddonPrice || 0) || 0;
    const removeBedAddonPounds = parseFloat(window.pdpState?.removeBedAddonPrice || 0) || 0;
    const removeMattressAddonPounds = parseFloat(window.pdpState?.removeMattressAddonPrice || 0) || 0;
    const roomOfChoiceAddonPounds = parseFloat(window.pdpState?.roomOfChoiceDeliveryAddonPrice || 0) || 0;
    const otherAddonsCents = Math.round((assemblyAddonPounds + removeBedAddonPounds + removeMattressAddonPounds + roomOfChoiceAddonPounds) * 100);

    const finalPriceCents = (variant.price || 0) + baseAddonCents + mattressAddonCents + otherAddonsCents;

    const hasAnyCompare = Boolean(
      (typeof variant.compare_at_price === 'number' && variant.compare_at_price) ||
      mattressAddonCompareCents
    );

    const baseComparePart = (typeof variant.compare_at_price === 'number' && variant.compare_at_price)
      ? (variant.compare_at_price + baseAddonCents + otherAddonsCents)
      : otherAddonsCents;
    const mattressComparePart = mattressAddonCompareCents ? mattressAddonCompareCents : mattressAddonCents;
    const finalCompareCents = hasAnyCompare ? (baseComparePart + mattressComparePart) : null;

    const price = (finalPriceCents / 100).toFixed(2);
    const compareAtPrice = finalCompareCents !== null ? (finalCompareCents / 100).toFixed(2) : null;

    const currentPriceEls = document.querySelectorAll('#currentPrice');
    currentPriceEls.forEach((el) => {
      el.textContent = `£${price}`;
    });

    const comparePriceEls = document.querySelectorAll('#comparePrice');
    const savingsEls = document.querySelectorAll('#savingsAmount');

    if (compareAtPrice) {
      comparePriceEls.forEach((el) => {
        el.textContent = `£${compareAtPrice}`;
        if (el.parentElement) el.parentElement.style.display = 'flex';
      });
      const savings = (parseFloat(compareAtPrice) - parseFloat(price)).toFixed(2);
      savingsEls.forEach((el) => {
        el.textContent = `SAVE £${savings}`;
        el.style.display = 'block';
      });
    } else {
      comparePriceEls.forEach((el) => {
        if (el.parentElement) el.parentElement.style.display = 'none';
      });
      savingsEls.forEach((el) => {
        el.style.display = 'none';
      });
    }
  }

  function syncSelectedVariantUI(productData) {
    if (!productData?.variants) return;

    const currentVariant = findCurrentVariant(productData);
    if (!currentVariant) return;

    window.pdpState._lastVariant = currentVariant;
    window.pdpState.productHandle = productData.handle;

    updatePriceBlockFromVariant(currentVariant);
    updateVariantURL(currentVariant.id, productData.handle);

    ['size', 'storage', 'headboard'].forEach((filterType) => {
      const baseline = getBaselineVariantForFilter(productData, filterType);
      if (!baseline) {
        updateFilterBarPrice(filterType, '', false);
        return;
      }
      const diffText = formatFilterBarDiff(currentVariant.price - baseline.price);
      if (diffText) updateFilterBarPrice(filterType, diffText, true);
      else updateFilterBarPrice(filterType, '', false);
    });

    // Base add-on (does not affect variant URL)
    const baseAddonPounds = parseFloat(window.pdpState?.basePrice || 0) || 0;
    const baseAddonCents = Math.round(baseAddonPounds * 100);
    const baseDiffText = formatFilterBarDiff(baseAddonCents);
    if (baseDiffText) updateFilterBarPrice('base', baseDiffText, true);
    else updateFilterBarPrice('base', '', false);
  }

  // Helper function to filter storage options based on size
  function filterStorageBySize(storageOptions, selectedSize) {
    if (!selectedSize || !storageOptions) return storageOptions;

    const sizeLower = selectedSize.toLowerCase();
    const isSmallSize = sizeLower.includes('small single') ||
      sizeLower.includes('single') && !sizeLower.includes('double') ||
      sizeLower.includes('2ft') ||
      sizeLower.includes('3ft');

    // For small sizes, exclude "Foot End" and "4 Drawers"
    if (isSmallSize) {
      const filtered = storageOptions.filter(storage => {
        const storageLower = storage.toLowerCase();
        return !storageLower.includes('foot end') && !storageLower.includes('4 drawer');
      });
      return filtered;
    }

    return storageOptions;
  }

  // Fetch product data via Shopify product JSON endpoint
  async function fetchProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) throw new Error('Product not found');
      return await response.json();
    } catch (error) {
      console.error('Error fetching product:', error);
      return null;
    }
  }

  const productDataCache = new Map();
  async function fetchProductDataCached(productHandle) {
    if (!productHandle) return null;
    if (productDataCache.has(productHandle)) return productDataCache.get(productHandle);
    const data = await fetchProductData(productHandle);
    if (data) productDataCache.set(productHandle, data);
    return data;
  }

  function getOptionIndexByName(productData, optionName) {
    const options = productData?.options;
    if (!Array.isArray(options)) return -1;
    const nameLower = String(optionName || '').toLowerCase();
    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      const optName = (typeof opt === 'string' ? opt : opt?.name) || '';
      if (String(optName).toLowerCase() === nameLower) return i;
    }
    return -1;
  }

  function findCheapestVariantByOptionValue(productData, optionName, value) {
    if (!productData?.variants) return null;
    const idx = getOptionIndexByName(productData, optionName);
    if (idx < 0) return null;
    const key = `option${idx + 1}`;
    const exact = productData.variants.filter(v => v && v[key] === value);
    if (exact.length > 0) return getCheapestVariant(exact);

    const targetNorm = normalizeText(value);
    const targetKey = normalizeKey(value);
    const normalized = productData.variants.filter((v) => v && (normalizeText(v[key]) === targetNorm || normalizeKey(v[key]) === targetKey));
    if (normalized.length > 0) return getCheapestVariant(normalized);

    // Last-resort fuzzy: contains match
    const fuzzy = productData.variants.filter((v) => v && normalizeText(v[key]).includes(targetNorm));
    return getCheapestVariant(fuzzy);
  }

  function updateBaseSelectionFromItem(baseItemEl) {
    const all = document.querySelectorAll('[data-base]');
    all.forEach((b) => b.classList.remove('selected'));
    const baseId = baseItemEl.getAttribute('data-base');
    if (baseId) {
      document.querySelectorAll(`[data-base="${baseId}"]`).forEach((b) => b.classList.add('selected'));
    }

    const title = baseItemEl.getAttribute('data-base-title') ||
      (baseItemEl.querySelector('.option-name')?.textContent || '').replace(/\s*\(\+£[\d.]+\)\s*/g, '').trim();
    let addonCents = parseInt(baseItemEl.getAttribute('data-base-addon-cents') || '0', 10) || 0;
    // Fallback to existing markup (e.g. "+£25") if metafield hydration didn't run yet.
    if (!addonCents) {
      const priceText = baseItemEl.querySelector('.option-price')?.textContent || '';
      const pounds = extractPrice(priceText);
      if (pounds) addonCents = Math.round(pounds * 100);
    }
    const addonPounds = addonCents / 100;

    window.pdpState.base = title || 'Standard Base';
    // Keep baseKey aligned with the UI keys (standard/reinforced) so selection works across rerenders.
    window.pdpState.baseKey = baseId || 'standard';
    window.pdpState.baseHandle = baseItemEl.getAttribute('data-base-handle') || '';
    window.pdpState.baseVariantId = baseItemEl.getAttribute('data-base-variant-id') || '';
    window.pdpState.basePrice = addonPounds;

    document.querySelectorAll('[data-filter="base"] .filter-value').forEach((el) => {
      el.textContent = window.pdpState.base;
    });

    const diffText = formatFilterBarDiff(addonCents);
    if (diffText) updateFilterBarPrice('base', diffText, true);
    else updateFilterBarPrice('base', '', false);

    updatePricing();
  }

  function attachBaseClickHandlers() {
    document.querySelectorAll('[data-base]').forEach((item) => {
      if (item.getAttribute('data-base-bound') === '1') return;
      item.setAttribute('data-base-bound', '1');
      item.addEventListener('click', () => updateBaseSelectionFromItem(item));
    });
  }

  async function updateBaseAddonPricesForSize(baseMetafield, selectedSize) {
    if (!Array.isArray(baseMetafield) || !selectedSize) return;

    const pickBaseHandle = () => {
      // Prefer an item that looks like “reinforced”, else first handle.
      for (const raw of baseMetafield) {
        const item = (typeof raw === 'string') ? { handle: raw } : raw;
        const title = String(item?.title || item?.name || '').toLowerCase();
        if (title.includes('reinforced') && item?.handle) return item.handle;
      }
      for (const raw of baseMetafield) {
        const item = (typeof raw === 'string') ? { handle: raw } : raw;
        if (item?.handle) return item.handle;
      }
      return '';
    };

    const reinforcedHandle = pickBaseHandle();
    if (!reinforcedHandle) return;

    const requestId = (window.pdpState._baseRequestId || 0) + 1;
    window.pdpState._baseRequestId = requestId;

    const baseProductData = await fetchProductDataCached(reinforcedHandle);
    if (!baseProductData) return;

    const variant = findCheapestVariantByOptionValue(baseProductData, 'size', selectedSize);
    if (!variant) return;

    // Treat base-product variant price as ADD-ON amount; Standard Base remains £0
    const addonCents = typeof variant.price === 'number' ? variant.price : 0;

    // If another size update happened while we were fetching, ignore
    if (window.pdpState._baseRequestId !== requestId) return;

    // Update existing “reinforced” UI (do not replace Liquid-rendered icons/markup)
    document.querySelectorAll('[data-base="reinforced"]').forEach((el) => {
      el.setAttribute('data-base-handle', reinforcedHandle);
      el.setAttribute('data-base-addon-cents', String(addonCents));
      el.setAttribute('data-base-variant-id', String(variant.id || ''));

      const priceSpan = el.querySelector('.option-price');
      if (priceSpan) {
        if (addonCents > 0) {
          priceSpan.textContent = `+£${(addonCents / 100).toFixed(2)}`;
          priceSpan.style.display = 'inline';
        } else {
          priceSpan.textContent = '';
          priceSpan.style.display = 'none';
        }
      }
    });

    // Keep currently selected base addon in sync (size change updates base addon)
    const selectedBase = document.querySelector('[data-base].selected');
    if (selectedBase) {
      const addonCents = parseInt(selectedBase.getAttribute('data-base-addon-cents') || '0', 10) || 0;
      window.pdpState.baseKey = selectedBase.getAttribute('data-base') || 'standard';
      window.pdpState.baseHandle = selectedBase.getAttribute('data-base-handle') || '';
      window.pdpState.baseVariantId = selectedBase.getAttribute('data-base-variant-id') || '';
      window.pdpState.basePrice = addonCents / 100;
      const diffText = formatFilterBarDiff(addonCents);
      if (diffText) updateFilterBarPrice('base', diffText, true);
      else updateFilterBarPrice('base', '', false);
      updatePricing();
    }
  }

  // Show existing skeleton loaders
  function showSkeletonLoaders() {
    const imageSkeletons = document.querySelectorAll('.pdp-img-skeleton');
    imageSkeletons.forEach(skeleton => {
      skeleton.style.opacity = '1';
      skeleton.style.visibility = 'visible';
    });

    const thumbnailSkeletons = document.querySelectorAll('.pdp-thumbnail-skeleton');
    thumbnailSkeletons.forEach(skeleton => {
      skeleton.style.opacity = '1';
      skeleton.style.visibility = 'visible';
    });

    const mainImages = document.querySelectorAll('.pdp-main-img');
    mainImages.forEach(img => {
      img.style.opacity = '0';
    });

    const thumbnailImages = document.querySelectorAll('.pdp-thumbnail-img');
    thumbnailImages.forEach(img => {
      img.style.opacity = '0';
    });
  }

  // Hide skeleton loaders
  function hideSkeletonLoaders() {
    const imageSkeletons = document.querySelectorAll('.pdp-img-skeleton');
    imageSkeletons.forEach(skeleton => {
      skeleton.style.opacity = '0';
      skeleton.style.visibility = 'hidden';
    });

    const thumbnailSkeletons = document.querySelectorAll('.pdp-thumbnail-skeleton');
    thumbnailSkeletons.forEach(skeleton => {
      skeleton.style.opacity = '0';
      skeleton.style.visibility = 'hidden';
    });
  }

  function renderColorSkeleton(grid) {
    if (!grid) return;
    const isMobileGrid = grid.classList.contains('mbl-clr-variant-wrapper');
    const count = isMobileGrid ? 8 : 10;

    const items = [];
    for (let i = 0; i < count; i += 1) {
      if (isMobileGrid) {
        items.push(
          `<li class="mbl-clr-variant-item shrink-0">
            <div class="bed-item rounded-md sonno-skeleton-card" aria-hidden="true">
              <div class="sonno-skeleton-img"></div>
              <div class="sonno-skeleton-text"></div>
            </div>
          </li>`
        );
      } else {
        items.push(
          `<li class="bed-item rounded-md sonno-skeleton-card" aria-hidden="true">
            <div class="sonno-skeleton-img"></div>
            <div class="sonno-skeleton-text"></div>
          </li>`
        );
      }
    }
    grid.innerHTML = items.join('');
  }

  // Update filter bar grid based on available options
  function updateFilterBarGrid() {
    // Get the visible filter bar (not hidden by responsive classes)
    const allFilterBars = document.querySelectorAll('.filter-bar');
    let visibleFilterBar = null;

    allFilterBars.forEach((bar) => {
      // offsetParent is null when an element or any ancestor is display:none
      if (bar && bar.offsetParent !== null) {
        visibleFilterBar = bar;
      }
    });

    if (!visibleFilterBar) {
      console.error('No visible filter bar found in updateFilterBarGrid!');
      return;
    }

    // During initial hydration, keep a stable layout via CSS.
    try {
      const root = visibleFilterBar.closest('.pdp-variant');
      if (root && root.getAttribute('data-sonno-pdp-init') === '1') {
        return;
      }
    } catch (_e) { }

    // console.log('=== updateFilterBarGrid START ===');

    // Get all filter items from the visible bar and check which ones are visible
    const allFilters = Array.from(visibleFilterBar.querySelectorAll('.filter-item'));
    // console.log('Total filter items:', allFilters.length);

    allFilters.forEach((item, index) => {
      const hasHiddenClass = item.classList.contains('filter-hidden');
      const filterType = item.getAttribute('data-filter');
      // console.log(`Filter ${index} (${filterType}):`);
      // console.log(`  - has filter-hidden class: ${hasHiddenClass}`);
      // console.log(`  - Is visible: ${!hasHiddenClass}`);
    });

    const visibleFilters = allFilters.filter(
      item => !item.classList.contains('filter-hidden')
    );
    const totalOptions = visibleFilters.length;

    // console.log('Visible filter count:', totalOptions);
    // console.log('Visible filters:', visibleFilters.map(f => f.getAttribute('data-filter')));

    // Update inline grid-template-columns style based on visible count
    const gridCols = `repeat(${totalOptions}, 1fr)`;

    visibleFilterBar.style.gridTemplateColumns = gridCols;
    // console.log('Grid columns set to:', gridCols);
    // console.log('=== updateFilterBarGrid END ===');
  }

  // Update price block with current variant info
  function updatePriceBlock() {
    const priceBlock = document.querySelector('.price-details');
    if (!priceBlock) {
      // console.log('Price block not found');
      return;
    }

    // Get current product handle
    const productHandle = window.pdpState?.productHandle;
    if (!productHandle) {
      // console.log('No product handle in state');
      return;
    }

    // Fetch product data to find current variant
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(productData => {
        const currentVariant = findCurrentVariant(productData);

        if (!currentVariant) {
          // console.log('No matching variant found for price update');
          return;
        }

        window.pdpState._lastVariant = currentVariant;
        updatePriceBlockFromVariant(currentVariant);
      })
      .catch(error => {
        console.error('Error updating price block:', error);
      });
  }

  // Update dynamic options sections (size, storage, headboard)
  let isUpdatingOptions = false;
  function updateDynamicOptions(productData) {
    // Prevent multiple simultaneous calls but allow retry after timeout
    if (isUpdatingOptions) {
      // console.log('⏭️ Skipping updateDynamicOptions - already running');
      return;
    }

    try {
      isUpdatingOptions = true;
      // console.log('=== updateDynamicOptions START ===');
      // console.log('Product data:', productData);
      // console.log('Product options:', productData.options);

      // Get the visible filter bar (not hidden by responsive classes)
      const allFilterBars = document.querySelectorAll('.filter-bar');
      let visibleFilterBar = null;

      allFilterBars.forEach((bar) => {
        if (bar && bar.offsetParent !== null) {
          visibleFilterBar = bar;
        }
      });

      if (!visibleFilterBar) {
        console.error('No visible filter bar found!');
        return;
      }

      // console.log('Working with visible filter bar');

      const activeFilter = (visibleFilterBar.querySelector('.filter-item.active') || {}).getAttribute
        ? visibleFilterBar.querySelector('.filter-item.active').getAttribute('data-filter')
        : '';

      // Always keep handle in sync
      window.pdpState = window.pdpState || {};
      window.pdpState.productHandle = productData.handle;

      function emitPdpStateChanged() {
        try {
          window.dispatchEvent(
            new CustomEvent('sonno:pdpStateChanged', {
              detail: { ...(window.pdpState || {}) },
            })
          );
        } catch (_e) {
          // no-op
        }
      }

      // Initialize default state from URL or first variant
      if (!window.pdpState || !window.pdpState.initialized) {
        // console.log('Initializing default state...');

        // Check if there's a variant parameter in URL
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');

        let initialVariant = null;
        if (variantId) {
          initialVariant = productData.variants.find(v => v.id === parseInt(variantId));
          // console.log('Found variant from URL:', initialVariant);
        }

        // If no URL variant, use first variant
        if (!initialVariant && productData.variants && productData.variants.length > 0) {
          initialVariant = productData.variants[0];
          // console.log('Using first variant as default:', initialVariant);
        }

        if (initialVariant) {
          // Set state from variant options
          window.pdpState = window.pdpState || {};
          window.pdpState.size = initialVariant.option1 || null;
          window.pdpState.storage = initialVariant.option2 || 'No Storage';
          window.pdpState.headboard = initialVariant.option3 || 'No Headboard';
          window.pdpState.base = 'Standard Base'; // Default base
          window.pdpState.productHandle = productData.handle;
          window.pdpState.initialized = true;

          // console.log('✅ Initial state set from variant:', window.pdpState);

          emitPdpStateChanged();

          // Update filter bar text with initial values
          if (window.pdpState.size) {
            document.querySelectorAll('[data-filter="size"] .filter-value').forEach(el => {
              el.textContent = window.pdpState.size;
            });
          }
          if (window.pdpState.storage) {
            document.querySelectorAll('[data-filter="storage"] .filter-value').forEach(el => {
              el.textContent = window.pdpState.storage;
            });
          }
          if (window.pdpState.headboard) {
            document.querySelectorAll('[data-filter="headboard"] .filter-value').forEach(el => {
              el.textContent = window.pdpState.headboard;
            });
          }

          // Apply initial selections to DOM immediately
          setTimeout(() => {
            // Select size
            if (window.pdpState.size) {
              document.querySelectorAll('[data-size]').forEach(item => {
                const sizeName = item.querySelector('.option-name')?.textContent.trim();
                if (sizeName === window.pdpState.size) {
                  item.classList.add('selected');
                } else {
                  item.classList.remove('selected');
                }
              });
            }

            // Select storage
            if (window.pdpState.storage) {
              document.querySelectorAll('[data-storage]').forEach(item => {
                const storageName = item.querySelector('.option-name')?.textContent.trim();
                if (storageName === window.pdpState.storage) {
                  item.classList.add('selected');
                } else {
                  item.classList.remove('selected');
                }
              });
            }

            // Select headboard
            if (window.pdpState.headboard) {
              document.querySelectorAll('[data-headboard]').forEach(item => {
                const headboardName = item.querySelector('.option-name')?.textContent.trim();
                if (headboardName === window.pdpState.headboard) {
                  item.classList.add('selected');
                } else {
                  item.classList.remove('selected');
                }
              });
            }

            // console.log('✅ Initial selections applied to DOM');

          }, 100);
        }
      }

      // Get base price (first variant or cheapest)
      const basePrice = productData.variants && productData.variants.length > 0
        ? Math.min(...productData.variants.map(v => v.price))
        : 0;

      // console.log('Base price for comparison:', basePrice);

      // Colour: hide entirely on narrow mobile (<= 650px)
      const colourFilterItem = visibleFilterBar.querySelector('[data-filter="colour"]');
      const hideColour = isNoColourMobile();
      if (colourFilterItem) {
        if (hideColour) {
          colourFilterItem.classList.add('filter-hidden');
          // console.log('✓ Colour filter: hidden (<=650px)');
        } else {
          colourFilterItem.classList.remove('filter-hidden');
          // console.log('✓ Colour filter: shown');
        }
      }

      // Hide colour section when in no-colour mobile mode
      if (hideColour) {
        document.querySelectorAll('#colourSection').forEach((el) => el.classList.add('hidden'));
      }

      // Update size section if Size option exists
      const sizeOption = productData.options?.find(opt => opt.name.toLowerCase() === 'size');
      const sizeSection = document.getElementById('sizeSection');
      const sizeFilterItem = visibleFilterBar.querySelector('[data-filter="size"]');

      // console.log('Size option:', sizeOption);

      if (sizeOption && sizeOption.values && sizeOption.values.length > 0) {
        // console.log('✓ Size option has', sizeOption.values.length, 'values:', sizeOption.values);

        // Update BOTH desktop and mobile size grids
        const allSizeGrids = document.querySelectorAll('#sizeSection .options-grid');
        // console.log('Found', allSizeGrids.length, 'size grids to update');

        // Get size option position
        const sizeOptionIndex = productData.options.findIndex(opt => opt.name.toLowerCase() === 'size');

        // Find the selected size's price (base for comparison)
        const selectedSizePrice = productData.variants?.find(v => {
          const optionKey = `option${sizeOptionIndex + 1}`;
          return v[optionKey] === window.pdpState?.size;
        })?.price || basePrice;

        // console.log('💰 Selected size:', window.pdpState?.size, 'Price:', selectedSizePrice);

        allSizeGrids.forEach(sizeGrid => {
          sizeGrid.innerHTML = '';

          sizeOption.values.forEach((size, index) => {
            // Check if this size matches the current state
            const isSelected = window.pdpState?.size === size;

            const li = document.createElement('li');
            li.className = `option-item flex flex-col item-center rounded-md ${isSelected ? 'selected' : ''}`;
            li.setAttribute('data-size', size.toLowerCase().replace(/\s+/g, '-'));

            // Find variant with this size to get price difference relative to SELECTED size
            let priceDiff = 0;
            let showPrice = false;
            const matchingVariant = productData.variants?.find(v => {
              const optionKey = `option${sizeOptionIndex + 1}`;
              return v[optionKey] === size;
            });

            if (matchingVariant) {
              priceDiff = ((matchingVariant.price - selectedSizePrice) / 100).toFixed(2);
              showPrice = matchingVariant.price !== selectedSizePrice;
              if (showPrice) {
                // console.log(`  ${size}: ${priceDiff > 0 ? '+' : ''}£${priceDiff}`);
              }
            }

            // Determine icon based on size name
            const sizeLower = size.toLowerCase();
            const isSingleBed = sizeLower.includes('small single') ||
              sizeLower.includes('single') && !sizeLower.includes('double') ||
              sizeLower.includes('2ft') ||
              sizeLower.includes('3ft');

            const isKingBed = sizeLower.includes('king');

            // Single bed icon
            const singleBedSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="46" height="56" viewBox="0 0 46 56" fill="none"> <path d="M8.52051 1.67749C8.52051 1.10053 8.98819 0.632812 9.56518 0.632812H35.4731C36.0501 0.632812 36.5178 1.10053 36.5178 1.67749V17.7655H8.52051V1.67749Z" stroke="#474546" stroke-width="0.8"/> <path d="M1.2832 36.1519L8.32482 17.7656H36.7134L43.7547 36.1519H1.2832Z" stroke="#474546" stroke-width="0.8"/> <path d="M1.02255 36.8075L1.24116 36.1516H43.7961L43.9425 36.5906C44.0064 36.7823 44.039 36.9831 44.039 37.1852V50.1502C44.039 51.1887 43.1971 52.0306 42.1586 52.0306H2.73563C1.73799 52.0306 0.921885 51.2574 0.874808 50.2703C0.780442 48.2915 0.661757 45.3777 0.633291 42.7532C0.619051 41.4402 0.627487 40.2069 0.672108 39.2024C0.717982 38.1698 0.80009 37.457 0.904293 37.1322C0.91652 37.0941 0.931463 37.0541 0.952691 36.9987C0.954111 36.9949 0.955566 36.9911 0.957053 36.9872C0.976008 36.9377 1.00035 36.874 1.02255 36.8075Z" stroke="#474546" stroke-width="0.8"/> <path d="M29.6224 10.6611H15.4148C14.8378 10.6611 14.3701 11.1289 14.3701 11.7058V20.0632C14.3701 20.6402 14.8378 21.1079 15.4148 21.1079H29.6224C30.1993 21.1079 30.6671 20.6402 30.6671 20.0632V11.7058C30.6671 11.1289 30.1993 10.6611 29.6224 10.6611Z" fill="#F2E8E0" stroke="#474546" stroke-width="0.8"/> <path d="M5.38516 51.8213H3.71387V55.9995H5.38516V51.8213Z" fill="#474546"/> <path d="M41.3227 51.8213H39.6514V55.9995H41.3227V51.8213Z" fill="#474546"/></svg>';

            const doubleBedSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="72" height="56" viewBox="0 0 72 56" fill="none"><path d="M12.7061 1.72622C12.7061 1.13151 13.1881 0.649414 13.7829 0.649414H57.7166C58.3113 0.649414 58.7934 1.13151 58.7934 1.72622V16.5862H12.7061V1.72622Z" stroke="#474546" stroke-width="0.8"/><path d="M1.14062 35.5376L12.4954 16.5858H58.9311L70.2855 35.5376H1.14062Z" stroke="#474546" stroke-width="0.8"/><path d="M8.08593 51.6895H5.39062V55.9967H8.08593V51.6895Z" fill="#474546"/><path d="M66.0352 51.6895H63.3398V55.9967H66.0352V51.6895Z" fill="#474546"/><path d="M31.8734 10.125H19.8131C19.2184 10.125 18.7363 10.6071 18.7363 11.2018V19.8163C18.7363 20.411 19.2184 20.8931 19.8131 20.8931H31.8734C32.4681 20.8931 32.9502 20.411 32.9502 19.8163V11.2018C32.9502 10.6071 32.4681 10.125 31.8734 10.125Z" fill="#F2E8E0" stroke="#474546" stroke-width="0.8"/><path d="M52.5482 10.125H40.4879C39.8932 10.125 39.4111 10.6071 39.4111 11.2018V19.8163C39.4111 20.411 39.8932 20.8931 40.4879 20.8931H52.5482C53.1429 20.8931 53.625 20.411 53.625 19.8163V11.2018C53.625 10.6071 53.1429 10.125 52.5482 10.125Z" fill="#F2E8E0" stroke="#474546" stroke-width="0.8"/><path d="M70.6313 36.0301C70.4329 35.7234 70.0924 35.5381 69.7271 35.5381H1.78627C1.3892 35.5381 1.02505 35.7589 0.84145 36.1109C0.762126 36.2631 0.720703 36.4321 0.720703 36.6037V50.398C0.720703 50.9928 1.20281 51.4748 1.79751 51.4748H69.7774C70.3721 51.4748 70.8542 50.9928 70.8542 50.398V36.6927C70.8542 36.4852 70.7942 36.2822 70.6816 36.108L70.6313 36.0301ZM70.6313 36.0301L70.3316 35.7238" stroke="#474546" stroke-width="0.8"/></svg>';

            const kingBedSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="77" height="56" viewBox="0 0 77 56" fill="none"><path d="M14.0645 1.75381C14.0645 1.14764 14.5456 0.65625 15.139 0.65625H60.99C61.5834 0.65625 62.0645 1.14765 62.0645 1.75381L62.626 19.0907L13.5002 18.9999L14.0645 1.75381Z" stroke="#474546" stroke-width="0.8"/><path d="M1.24023 36.769L13.2615 19.0996H62.7891L74.8099 36.769H1.24023Z" stroke="#474546" stroke-width="0.8"/><path d="M8.6089 51.9648H5.73926V56.0033H8.6089V51.9648Z" fill="#474546"/><path d="M70.3111 51.9648H67.4414V56.0033H70.3111V51.9648Z" fill="#474546"/><path d="M34.0209 13.042H21.012C20.4079 13.042 19.9182 13.5317 19.9182 14.1357V21.9435C19.9182 22.5475 20.4079 23.0372 21.012 23.0372H34.0209C34.625 23.0372 35.1147 22.5475 35.1147 21.9435V14.1357C35.1147 13.5317 34.625 13.042 34.0209 13.042Z" fill="#F2E8E0" stroke="#474546" stroke-width="0.8"/><path d="M56.0344 13.042H43.0254C42.4213 13.042 41.9316 13.5317 41.9316 14.1357V21.9435C41.9316 22.5475 42.4213 23.0372 43.0254 23.0372H56.0344C56.6384 23.0372 57.1281 22.5475 57.1281 21.9435V14.1357C57.1281 13.5317 56.6384 13.042 56.0344 13.042Z" fill="#F2E8E0" stroke="#474546" stroke-width="0.8"/><path d="M75.2611 37.3515C75.3991 37.5392 75.4733 37.7661 75.4733 37.9989V50.6186C75.4733 51.2227 74.9837 51.7124 74.3795 51.7124H1.82917C1.22507 51.7124 0.735352 51.2227 0.735352 50.6186V37.8824C0.735352 37.7009 0.78414 37.5227 0.876613 37.3666C1.05885 37.0589 1.38997 36.8701 1.74765 36.8701H74.3538C74.702 36.8701 75.0293 37.0359 75.2354 37.3165L75.2611 37.3515Z" stroke="#474546" stroke-width="0.8"/></svg>';

            const mediumSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="134" height="93" class="product-svg-size" viewBox="0 0 77 39" fill="none"><path d="M0.786851 2.86835L1.07733 1.69872C1.21575 1.14134 1.71616 0.75 2.29047 0.75H74.6224C75.1711 0.75 75.6556 1.10775 75.8171 1.63208L76.1946 2.85808C76.2313 2.97727 76.25 3.10128 76.25 3.226V37C76.25 37.6904 75.6904 38.25 75 38.25H2C1.30964 38.25 0.75 37.6904 0.75 37V3.16963C0.75 3.06808 0.762375 2.96691 0.786851 2.86835Z" stroke="#7f285b" stroke-width="1.3"></path><path d="M28.8527 29C28.6327 29 28.5227 28.88 28.5227 28.64L28.9127 9.71C28.9127 9.47 29.0327 9.35 29.2727 9.35H33.1427C33.3227 9.35 33.4527 9.44 33.5327 9.62L38.5427 20.54L43.4627 9.62C43.5627 9.44 43.7027 9.35 43.8827 9.35H47.7527C47.9727 9.35 48.0827 9.47 48.0827 9.71L48.5027 28.64C48.5027 28.88 48.3827 29 48.1427 29H45.3227C45.0827 29 44.9627 28.88 44.9627 28.64L44.7227 18.95C44.7027 18.15 44.7127 17.35 44.7527 16.55C44.7927 15.73 44.8227 14.93 44.8427 14.15H44.7527C44.4327 14.93 44.0927 15.72 43.7327 16.52C43.3927 17.3 43.0327 18.07 42.6527 18.83L38.9627 26.6C38.8827 26.76 38.7427 26.84 38.5427 26.84H38.4227C38.2427 26.84 38.1127 26.76 38.0327 26.6L34.3127 18.74C33.9327 18 33.5727 17.24 33.2327 16.46C32.8927 15.66 32.5727 14.89 32.2727 14.15H32.1827C32.2227 14.91 32.2527 15.7 32.2727 16.52C32.2927 17.32 32.2927 18.11 32.2727 18.89L32.0327 28.64C32.0327 28.88 31.9227 29 31.7027 29H28.8527Z" fill="#7f285b"></path></svg>';

            const largeSvg = '<svg xmlns="http://www.w3.org/2000/svg" class="product-svg-size" width="134" height="93" viewBox="0 0 87 39" fill="none"><path d="M0.796483 2.86258L1.13328 1.66229C1.28465 1.12283 1.7765 0.75 2.3368 0.75H84.5605C85.0925 0.75 85.5662 1.08674 85.7411 1.5892L86.1806 2.85223C86.2265 2.98431 86.25 3.12318 86.25 3.26303V37C86.25 37.6904 85.6904 38.25 85 38.25H2C1.30964 38.25 0.75 37.6904 0.75 37V3.20028C0.75 3.08612 0.76564 2.9725 0.796483 2.86258Z" stroke="#7f285b" stroke-width="1.5"></path><path d="M38.7404 29C38.5204 29 38.4104 28.88 38.4104 28.64V9.71C38.4104 9.47 38.5204 9.35 38.7404 9.35H41.6804C41.9004 9.35 42.0104 9.47 42.0104 9.71V25.82H49.9004C50.1404 25.82 50.2604 25.94 50.2604 26.18V28.64C50.2604 28.88 50.1404 29 49.9004 29H38.7404Z" fill="#7f285b"></path></svg>';

            const sizeSlug = size.toLowerCase().replace(/\s+/g, '-');

            const iconHtml = (() => {
              switch (sizeSlug) {
                case 'small-single-2ft6':
                case 'single-3ft':
                  return singleBedSvg;

                case 'small-double-4ft':
                case 'double-4ft6':
                  return doubleBedSvg;

                case 'king-5ft':
                case 'super-king-6ft':
                  return kingBedSvg;

                case 'medium':
                  return mediumSvg;
                case 'large':
                  return largeSvg;

                // case 'medium':
                // case 'large':
                //   return doubleBedSvg;

                default:
                  return isSingleBed ? singleBedSvg : (isKingBed ? kingBedSvg : doubleBedSvg);
              }
            })();

            li.innerHTML = `
            <div class="option-icon">
              ${iconHtml}
            </div>
            <div class="option-name fw-medium text-gray text-center">${size}</div>
            ${showPrice ? `<div class="option-price fw-medium text-gray text-center">${priceDiff > 0 ? '+' : ''}£${priceDiff}</div>` : ''}
          `;
            // Attach click event listener directly
            li.addEventListener('click', async () => {
              document.querySelectorAll('[data-size]').forEach((s) => s.classList.remove('selected'));
              document.querySelectorAll(`[data-size="${li.getAttribute('data-size')}"]`).forEach((s) => s.classList.add('selected'));

              const sizeName = li.querySelector('.option-name').textContent.trim();

              window.pdpState.size = sizeName;
              emitPdpStateChanged();

              // Update filter bar text
              document.querySelectorAll('[data-filter="size"] .filter-value').forEach((el) => {
                el.textContent = sizeName;
              });

              // console.log('🔄 Size changed to:', sizeName, '- Updating storage and headboard options...');

              // Update storage and headboard options based on new size
              const currentHandle = getCurrentHandle();
              if (currentHandle) {
                const productData = await fetchProductData(currentHandle);
                if (productData) {
                  // Call updateDynamicOptions to filter storage and headboard
                  await updateDynamicOptions(productData);

                  // Update variant URL
                  const currentVariant = findCurrentVariant(productData);
                  if (currentVariant) {
                    updateVariantURL(currentVariant.id, currentHandle);
                  }
                }
              }

              updatePricing();
            });

            sizeGrid.appendChild(li);
          });
        });

        // console.log('✓ All size grids populated with', sizeOption.values.length, 'items');

        // Show size filter and section
        if (sizeFilterItem) {
          // console.log('BEFORE removing filter-hidden from Size:', sizeFilterItem.classList.contains('filter-hidden'));
          sizeFilterItem.classList.remove('filter-hidden');
          // console.log('AFTER removing filter-hidden from Size:', sizeFilterItem.classList.contains('filter-hidden'));
          // console.log('Size element classes:', sizeFilterItem.className);
          // console.log('✓ Size filter item shown (class removed)');
        }
        if (sizeSection && activeFilter === 'size') {
          sizeSection.classList.remove('hidden');
          // console.log('✓ Size section visible');
        }
      } else {
        // console.log('✗ Size option not found or empty');
        if (sizeFilterItem) sizeFilterItem.classList.add('filter-hidden');
        if (sizeSection) sizeSection.classList.add('hidden');
      }

      // Update storage section if Storage option exists
      const storageOption = productData.options?.find(opt => opt.name.toLowerCase() === 'storage');
      const storageSection = document.getElementById('storageSection');
      const storageFilterItem = visibleFilterBar.querySelector('[data-filter="storage"]');

      // console.log('Storage option:', storageOption);

      if (storageOption && storageOption.values && storageOption.values.length > 0) {
        // console.log('✓ Storage option has', storageOption.values.length, 'values');

        // Get selected size to filter storage options
        const selectedSize = window.pdpState?.size || (sizeOption && sizeOption.values && sizeOption.values[0]) || '';

        // Find which storage options have variants for this size
        const sizeOptionIndex = productData.options.findIndex(opt => opt.name.toLowerCase() === 'size');
        const storageOptionIndex = productData.options.findIndex(opt => opt.name.toLowerCase() === 'storage');
        const headboardOptionIndex = productData.options.findIndex(opt => opt.name.toLowerCase() === 'headboard');

        const selectedHeadboard = window.pdpState?.headboard;
        const headboardKey = headboardOptionIndex >= 0 ? `option${headboardOptionIndex + 1}` : null;
        const hasHeadboardContext = Boolean(headboardKey && selectedHeadboard);

        // console.log('═══════════════════════════════════════════════════');
        // console.log('🔍 STORAGE FILTERING FOR SIZE:', selectedSize);
        // console.log('═══════════════════════════════════════════════════');
        // console.log('Total storage options in product:', storageOption.values);
        // console.log('Checking variants for size:', selectedSize);

        const availableStorageForSize = [];
        storageOption.values.forEach(storage => {
          // Check if there's a variant with this size + storage combination
          const matchingVariants = productData.variants?.filter(v => {
            const variantSize = v[`option${sizeOptionIndex + 1}`];
            const variantStorage = v[`option${storageOptionIndex + 1}`];
            return variantSize === selectedSize && variantStorage === storage;
          });

          if (matchingVariants && matchingVariants.length > 0) {
            availableStorageForSize.push(storage);
            // console.log(`  ✅ ${storage}: ${matchingVariants.length} variants found`);
          } else {
            // console.log(`  ❌ ${storage}: No variants found`);
          }
        });

        // console.log('───────────────────────────────────────────────────');
        // console.log('✓ Available storage for', selectedSize, ':', availableStorageForSize);
        // console.log('═══════════════════════════════════════════════════');

        // If current storage is not available, select first available option
        if (window.pdpState?.storage) {
          const storageAvailable = availableStorageForSize.some(
            opt => opt.toLowerCase().trim() === window.pdpState.storage.toLowerCase().trim()
          );
          if (!storageAvailable && availableStorageForSize.length > 0) {
            const newStorage = availableStorageForSize[0];
            // console.log('⚠️ Storage reset from', window.pdpState.storage, 'to:', newStorage);
            window.pdpState.storage = newStorage;
            // Update filter bar text immediately
            document.querySelectorAll('[data-filter="storage"] .filter-value').forEach(el => {
              el.textContent = newStorage;
            });

            // Update filter bar price (relative to first storage for this size)
            const firstStorageVariant = productData.variants?.find(v => v.option1 === selectedSize);
            const newStorageVariant = productData.variants?.find(v =>
              v.option1 === selectedSize && v.option2 === newStorage
            );
            if (firstStorageVariant && newStorageVariant) {
              const storagePriceDiff = ((newStorageVariant.price - firstStorageVariant.price) / 100).toFixed(2);
              if (parseFloat(storagePriceDiff) !== 0) {
                updateFilterBarPrice('storage', `(${parseFloat(storagePriceDiff) > 0 ? '+' : ''}£${storagePriceDiff})`, true);
              } else {
                updateFilterBarPrice('storage', '', false);
              }
            }
          }
        } else {
          const defaultStorage = availableStorageForSize[0] || 'No Storage';
          window.pdpState.storage = defaultStorage;
          // Update filter bar text immediately
          document.querySelectorAll('[data-filter="storage"] .filter-value').forEach(el => {
            el.textContent = defaultStorage;
          });

          // Update filter bar price
          const firstStorageVariant = productData.variants?.find(v => v.option1 === selectedSize);
          const defaultStorageVariant = productData.variants?.find(v =>
            v.option1 === selectedSize && v.option2 === defaultStorage
          );
          if (firstStorageVariant && defaultStorageVariant) {
            const storagePriceDiff = ((defaultStorageVariant.price - firstStorageVariant.price) / 100).toFixed(2);
            if (parseFloat(storagePriceDiff) !== 0) {
              updateFilterBarPrice('storage', `(${parseFloat(storagePriceDiff) > 0 ? '+' : ''}£${storagePriceDiff})`, true);
            } else {
              updateFilterBarPrice('storage', '', false);
            }
          }
        }

        // Update ALL storage grids (both desktop and mobile)
        const allStorageGrids = document.querySelectorAll('#storageSection .options-grid');
        // console.log('📦 Found', allStorageGrids.length, 'storage grids (desktop + mobile)');

        // Find the selected storage's price (base for comparison with this size)
        // Use the CHEAPEST variant for (size + storage) to avoid accidentally comparing
        // against a different headboard/variant price.
        const selectedStoragePrice =
          getMinVariantPrice(productData.variants, (v) => {
            const matches =
              v[`option${sizeOptionIndex + 1}`] === selectedSize &&
              v[`option${storageOptionIndex + 1}`] === window.pdpState?.storage;
            if (!matches) return false;
            if (!hasHeadboardContext) return true;
            return v[headboardKey] === selectedHeadboard;
          }) ??
          // Fallback if the current headboard doesn't exist for this size+storage
          getMinVariantPrice(productData.variants, (v) =>
            v[`option${sizeOptionIndex + 1}`] === selectedSize &&
            v[`option${storageOptionIndex + 1}`] === window.pdpState?.storage
          ) ??
          getMinVariantPrice(productData.variants, (v) =>
            v[`option${sizeOptionIndex + 1}`] === selectedSize
          ) ??
          basePrice;

        allStorageGrids.forEach((storageGrid, gridIndex) => {
          const allStorageItems = storageGrid.querySelectorAll('[data-storage]');
          let visibleCount = 0;

          // console.log(`  Grid ${gridIndex + 1}: Found ${allStorageItems.length} storage items`);

          allStorageItems.forEach((item, index) => {
            const storageName = item.querySelector('.option-name')?.textContent.trim();
            const dataStorage = item.getAttribute('data-storage');

            const shouldShow = availableStorageForSize.some(
              opt => opt.toLowerCase().trim() === storageName?.toLowerCase().trim()
            );

            if (gridIndex === 0) {
              // console.log(`    Item ${index + 1}: "${storageName}" - ${shouldShow ? '✅ SHOW' : '❌ HIDE'}`);
            }

            if (shouldShow) {
              // Find price for this size + storage (cheapest across headboards)
              const optionPrice =
                getMinVariantPrice(productData.variants, (v) => {
                  const matches =
                    v[`option${sizeOptionIndex + 1}`] === selectedSize &&
                    v[`option${storageOptionIndex + 1}`] === storageName;
                  if (!matches) return false;
                  if (!hasHeadboardContext) return true;
                  return v[headboardKey] === selectedHeadboard;
                }) ??
                // Fallback if this storage doesn't exist for current headboard
                getMinVariantPrice(productData.variants, (v) =>
                  v[`option${sizeOptionIndex + 1}`] === selectedSize &&
                  v[`option${storageOptionIndex + 1}`] === storageName
                );

              // Update price display relative to selected storage
              let priceEl = item.querySelector('.option-price');
              if (typeof optionPrice === 'number') {
                const priceDiff = optionPrice - selectedStoragePrice;
                if (priceDiff !== 0) {
                  // Create price element if it doesn't exist
                  if (!priceEl) {
                    priceEl = document.createElement('div');
                    priceEl.className = 'option-price fw-medium text-gray text-center';
                    item.appendChild(priceEl);
                  }
                  const formattedPrice = (priceDiff / 100).toFixed(2);
                  priceEl.textContent = `${priceDiff > 0 ? '+' : ''}£${formattedPrice}`;
                  priceEl.style.display = 'block';
                } else if (priceEl) {
                  priceEl.style.display = 'none';
                }
              } else if (priceEl) {
                priceEl.style.display = 'none';
              }

              item.style.display = 'flex';
              item.style.visibility = 'visible';
              item.classList.remove('hidden');
              visibleCount++;
              // Update selected state
              if (storageName?.toLowerCase().trim() === window.pdpState?.storage?.toLowerCase().trim()) {
                item.classList.add('selected');
              } else {
                item.classList.remove('selected');
              }
            } else {
              item.style.display = 'none';
              item.style.visibility = 'hidden';
              item.classList.add('hidden');
              item.classList.remove('selected');
              if (gridIndex === 0) {
                // console.log(`      → Applied: display=none, visibility=hidden, added .hidden class`);
                // Verify it was applied
                setTimeout(() => {
                  const computedDisplay = window.getComputedStyle(item).display;
                  const computedVisibility = window.getComputedStyle(item).visibility;
                  // console.log(`      → Verified: display=${computedDisplay}, visibility=${computedVisibility}`);
                }, 100);
              }
            }
          });

          // console.log(`  ✓ Grid ${gridIndex + 1}: showing ${visibleCount} of ${allStorageItems.length} items`);
        });

        // Show storage filter and section
        if (storageFilterItem) {
          storageFilterItem.classList.remove('filter-hidden');
          // console.log('✓ Storage filter item shown (class removed)');
        }
        if (storageSection && activeFilter === 'storage') {
          storageSection.classList.remove('hidden');
          // console.log('✓ Storage section visible');
        }
      } else {
        // console.log('✗ Storage option not found or empty');
        if (storageFilterItem) storageFilterItem.classList.add('filter-hidden');
        if (storageSection) storageSection.classList.add('hidden');
      }

      // Update headboard section if Headboard option exists
      const headboardOption = productData.options?.find(opt => opt.name.toLowerCase() === 'headboard');
      const headboardSection = document.getElementById('headboardSection');
      const headboardFilterItem = visibleFilterBar.querySelector('[data-filter="headboard"]');

      // console.log('Headboard option:', headboardOption);

      if (headboardOption && headboardOption.values && headboardOption.values.length > 0) {
        // console.log('✓ Headboard option has', headboardOption.values.length, 'values');

        // Find which headboard options have variants for this size + storage
        const sizeOptionIndex = productData.options.findIndex(opt => opt.name.toLowerCase() === 'size');
        const storageOptionIndex = productData.options.findIndex(opt => opt.name.toLowerCase() === 'storage');
        const headboardOptionIndex = productData.options.findIndex(opt => opt.name.toLowerCase() === 'headboard');

        // Get selected size and storage to filter headboard options
        const selectedSize = window.pdpState?.size || (sizeOption && sizeOption.values && sizeOption.values[0]) || '';
        // If the product doesn't have a Storage option, do NOT try to match storage.
        const selectedStorage = storageOptionIndex >= 0 ? (window.pdpState?.storage || 'No Storage') : '';

        // console.log('═══════════════════════════════════════════════════');
        // console.log('🔍 HEADBOARD FILTERING FOR:');
        // console.log('   Size:', selectedSize);
        // console.log('   Storage:', selectedStorage);
        // console.log('═══════════════════════════════════════════════════');
        // console.log('Total headboard options in product:', headboardOption.values);

        const availableHeadboardsForSelection = [];
        headboardOption.values.forEach(headboard => {
          // Check if there's a variant with this size + storage + headboard combination
          const matchingVariants = productData.variants?.filter(v => {
            const variantSize = v[`option${sizeOptionIndex + 1}`];
            const variantStorage = storageOptionIndex >= 0 ? v[`option${storageOptionIndex + 1}`] : null;
            const variantHeadboard = v[`option${headboardOptionIndex + 1}`];
            const okSize = variantSize === selectedSize;
            const okStorage = storageOptionIndex >= 0 ? (variantStorage === selectedStorage) : true;
            const okHeadboard = variantHeadboard === headboard;
            return okSize && okStorage && okHeadboard;
          });

          if (matchingVariants && matchingVariants.length > 0) {
            availableHeadboardsForSelection.push(headboard);
            // console.log(`  ✅ ${headboard}: ${matchingVariants.length} variants found`);
          } else {
            // console.log(`  ❌ ${headboard}: No variants found`);
          }
        });

        // console.log('───────────────────────────────────────────────────');
        // console.log('✓ Available headboards:', availableHeadboardsForSelection);
        // console.log('═══════════════════════════════════════════════════');

        // If current headboard is not available, select first available option
        if (window.pdpState?.headboard) {
          const headboardAvailable = availableHeadboardsForSelection.some(
            opt => opt.toLowerCase().trim() === window.pdpState.headboard.toLowerCase().trim()
          );
          if (!headboardAvailable && availableHeadboardsForSelection.length > 0) {
            const newHeadboard = availableHeadboardsForSelection[0];
            // console.log('⚠️ Headboard reset from', window.pdpState.headboard, 'to:', newHeadboard);
            window.pdpState.headboard = newHeadboard;
            emitPdpStateChanged();
            // Update filter bar text immediately
            setHeadboardFilterText(newHeadboard);

            // Update filter bar price (relative to first headboard for this size+storage)
            const firstHeadboardVariant = productData.variants?.find(v =>
              v.option1 === selectedSize && v.option2 === selectedStorage
            );
            const newHeadboardVariant = productData.variants?.find(v =>
              v.option1 === selectedSize &&
              v.option2 === selectedStorage &&
              v.option3 === newHeadboard
            );
            if (firstHeadboardVariant && newHeadboardVariant) {
              const headboardPriceDiff = ((newHeadboardVariant.price - firstHeadboardVariant.price) / 100).toFixed(2);
              if (parseFloat(headboardPriceDiff) !== 0) {
                updateFilterBarPrice('headboard', `(${parseFloat(headboardPriceDiff) > 0 ? '+' : ''}£${headboardPriceDiff})`, true);
              } else {
                updateFilterBarPrice('headboard', '', false);
              }
            }
          }
        } else {
          const defaultHeadboard = availableHeadboardsForSelection[0] || headboardOption.values[0];
          window.pdpState.headboard = defaultHeadboard;
          emitPdpStateChanged();
          // Update filter bar text immediately
          setHeadboardFilterText(defaultHeadboard);

          // Update filter bar price
          const firstHeadboardVariant = productData.variants?.find(v =>
            v.option1 === selectedSize && v.option2 === selectedStorage
          );
          const defaultHeadboardVariant = productData.variants?.find(v =>
            v.option1 === selectedSize &&
            v.option2 === selectedStorage &&
            v.option3 === defaultHeadboard
          );
          if (firstHeadboardVariant && defaultHeadboardVariant) {
            const headboardPriceDiff = ((defaultHeadboardVariant.price - firstHeadboardVariant.price) / 100).toFixed(2);
            if (parseFloat(headboardPriceDiff) !== 0) {
              updateFilterBarPrice('headboard', `(${parseFloat(headboardPriceDiff) > 0 ? '+' : ''}£${headboardPriceDiff})`, true);
            } else {
              updateFilterBarPrice('headboard', '', false);
            }
          }
        }

        // Update ALL headboard grids (both desktop and mobile)
        const allHeadboardGrids = document.querySelectorAll('#headboardSection .options-grid');
        // console.log('🛏️ Found', allHeadboardGrids.length, 'headboard grids (desktop + mobile)');

        // Find the selected headboard's price (base for comparison with this size+storage)
        const selectedHeadboardVariant = productData.variants?.find(v => {
          const okSize = v[`option${sizeOptionIndex + 1}`] === selectedSize;
          const okStorage = storageOptionIndex >= 0 ? (v[`option${storageOptionIndex + 1}`] === selectedStorage) : true;
          const okHeadboard = v[`option${headboardOptionIndex + 1}`] === window.pdpState?.headboard;
          return okSize && okStorage && okHeadboard;
        });
        const selectedHeadboardPrice =
          selectedHeadboardVariant?.price ||
          Math.min(
            ...productData.variants
              .filter(v => {
                const okSize = v[`option${sizeOptionIndex + 1}`] === selectedSize;
                const okStorage = storageOptionIndex >= 0 ? (v[`option${storageOptionIndex + 1}`] === selectedStorage) : true;
                return okSize && okStorage;
              })
              .map(v => v.price)
          );

        allHeadboardGrids.forEach((headboardGrid, gridIndex) => {
          const allHeadboardItems = headboardGrid.querySelectorAll('[data-headboard]');
          let visibleCount = 0;

          // console.log(`  Grid ${gridIndex + 1}: Found ${allHeadboardItems.length} headboard items`);

          allHeadboardItems.forEach((item, index) => {
            const headboardName = item.querySelector('.option-name')?.textContent.trim();
            const shouldShow = availableHeadboardsForSelection.some(
              opt => opt.toLowerCase().trim() === headboardName?.toLowerCase().trim()
            );

            if (gridIndex === 0) {
              // console.log(`    Item ${index + 1}: "${headboardName}" - ${shouldShow ? '✅ SHOW' : '❌ HIDE'}`);
            }

            if (shouldShow) {
              // Find variant for this size + storage + headboard to get price relative to SELECTED headboard
              const variant = productData.variants?.find(v => {
                const okSize = v[`option${sizeOptionIndex + 1}`] === selectedSize;
                const okStorage = storageOptionIndex >= 0 ? (v[`option${storageOptionIndex + 1}`] === selectedStorage) : true;
                const okHeadboard = v[`option${headboardOptionIndex + 1}`] === headboardName;
                return okSize && okStorage && okHeadboard;
              });

              // Update price display relative to selected headboard
              let priceEl = item.querySelector('.option-price');
              if (variant) {
                const priceDiff = variant.price - selectedHeadboardPrice;
                if (priceDiff !== 0) {
                  // Create price element if it doesn't exist
                  if (!priceEl) {
                    priceEl = document.createElement('div');
                    priceEl.className = 'option-price fw-medium text-gray text-center';
                    item.appendChild(priceEl);
                  }
                  const formattedPrice = (priceDiff / 100).toFixed(2);
                  priceEl.textContent = `${priceDiff > 0 ? '+' : ''}£${formattedPrice}`;
                  priceEl.style.display = 'block';
                } else if (priceEl) {
                  priceEl.style.display = 'none';
                }
              }

              item.style.display = 'flex';
              item.style.visibility = 'visible';
              item.classList.remove('hidden');
              visibleCount++;
              // Update selected state
              if (headboardName?.toLowerCase().trim() === window.pdpState?.headboard?.toLowerCase().trim()) {
                item.classList.add('selected');
              } else {
                item.classList.remove('selected');
              }
            } else {
              item.style.display = 'none';
              item.style.visibility = 'hidden';
              item.classList.add('hidden');
              item.classList.remove('selected');
            }
          });

          // console.log(`  ✓ Grid ${gridIndex + 1}: showing ${visibleCount} of ${allHeadboardItems.length} items`);
        });

        // Show headboard filter and section
        if (headboardFilterItem) {
          headboardFilterItem.classList.remove('filter-hidden');
          // console.log('✓ Headboard filter item shown (class removed)');
        }
        if (headboardSection && activeFilter === 'headboard') {
          headboardSection.classList.remove('hidden');
          // console.log('✓ Headboard section visible');
        }
      } else {
        // console.log('✗ Headboard option not found or empty');
        if (headboardFilterItem) headboardFilterItem.classList.add('filter-hidden');
        if (headboardSection) headboardSection.classList.add('hidden');
      }

      // Check for Base option based on metafield data-base-metafield
      const baseSection = document.getElementById('baseSection');
      const baseFilterItem = visibleFilterBar.querySelector('[data-filter="base"]');

      // Get base metafield from the data attribute on visible filter bar
      let baseMetafield = null;
      let hasBaseMetafield = false;

      if (visibleFilterBar) {
        const baseMetafieldAttr = visibleFilterBar.getAttribute('data-base-metafield');
        // console.log('Base metafield attribute:', baseMetafieldAttr);

        if (baseMetafieldAttr && baseMetafieldAttr !== '' && baseMetafieldAttr !== 'null') {
          try {
            const decodedBaseMetafield = decodeHtmlEntities(baseMetafieldAttr);
            baseMetafield = JSON.parse(decodedBaseMetafield);

            // Normalize to an array of objects with at least {handle}
            if (baseMetafield && typeof baseMetafield === 'object' && !Array.isArray(baseMetafield)) {
              if (Array.isArray(baseMetafield.products)) baseMetafield = baseMetafield.products;
              else if (Array.isArray(baseMetafield.value)) baseMetafield = baseMetafield.value;
              else if (Array.isArray(baseMetafield.items)) baseMetafield = baseMetafield.items;
            }
            if (Array.isArray(baseMetafield)) {
              baseMetafield = baseMetafield
                .map((item) => (typeof item === 'string' ? { handle: item } : item))
                .filter((item) => item && (item.handle || item.id || item.title || item.name));
            }

            hasBaseMetafield = baseMetafield && (Array.isArray(baseMetafield) ? baseMetafield.length > 0 : Object.keys(baseMetafield).length > 0);
            // console.log('Parsed base metafield:', baseMetafield);
          } catch (e) {
            console.log('Could not parse base metafield:', e);
          }
        }
      }

      // console.log('Has base metafield:', hasBaseMetafield);

      if (hasBaseMetafield && baseSection && baseFilterItem) {
        // Ensure state is valid for the existing markup (standard/reinforced)
        const key = window.pdpState.baseKey;
        if (key !== 'standard' && key !== 'reinforced') {
          window.pdpState.baseKey = 'standard';
          window.pdpState.base = 'Standard Base';
          window.pdpState.basePrice = 0;
          window.pdpState.baseHandle = '';
        }

        // Sync filter-bar label to selected base
        const baseLabel = (window.pdpState.baseKey || 'standard') === 'reinforced' ? 'Reinforced base' : 'Standard Base';
        window.pdpState.base = baseLabel;
        document.querySelectorAll('[data-filter="base"] .filter-value').forEach((el) => {
          el.textContent = baseLabel;
        });

        // Hydrate the existing two base items in BOTH desktop & mobile (do not rebuild DOM)
        document.querySelectorAll('#baseSection .options-grid').forEach((baseGrid) => {
          const standardEl = baseGrid.querySelector('[data-base="standard"]');
          const reinforcedEl = baseGrid.querySelector('[data-base="reinforced"]');

          if (standardEl) {
            standardEl.setAttribute('data-base-title', 'Standard Base');
            standardEl.setAttribute('data-base-addon-cents', '0');
            if ((window.pdpState.baseKey || 'standard') === 'standard') standardEl.classList.add('selected');
            else standardEl.classList.remove('selected');
          }

          if (reinforcedEl) {
            reinforcedEl.setAttribute('data-base-title', 'Reinforced base');
            // addon cents is hydrated async by size below
            if ((window.pdpState.baseKey || 'standard') === 'reinforced') reinforcedEl.classList.add('selected');
            else reinforcedEl.classList.remove('selected');
          }
        });

        attachBaseClickHandlers();
        void updateBaseAddonPricesForSize(baseMetafield, window.pdpState?.size);

        baseFilterItem.classList.remove('filter-hidden');
        if (activeFilter === 'base') baseSection.classList.remove('hidden');
        // console.log('✓ Base filter: shown (metafield present)');
      } else {
        // console.log('✗ Base filter: hidden (no metafield)');
        if (baseFilterItem) baseFilterItem.classList.add('filter-hidden');
        if (baseSection) baseSection.classList.add('hidden');
      }

      // console.log('=== updateDynamicOptions END ===');

      // Force a reflow to ensure all style changes are applied
      if (visibleFilterBar) {
        // Trigger reflow
        void visibleFilterBar.offsetHeight;
      }

      // Sync URL, filter-bar prices, and top price from selected variant
      syncSelectedVariantUI(productData);

      // Update filter bar grid layout immediately with a small delay to ensure DOM updates
      setTimeout(() => {
        updateFilterBarGrid();
      }, 100);

      // NOTE: We do NOT call initVariantSelector() here anymore.
      // Event listeners are only attached once on initial page load.
      // The size grid regeneration happens in this function, and we manually
      // attach click handlers to the new size items right after creating them.

      isUpdatingOptions = false; // Reset flag after all operations complete

    } catch (error) {
      console.error('Error in updateDynamicOptions:', error);
      isUpdatingOptions = false; // Reset flag on error
    }
  }

  // Update page content with new product data (without full reload)
  async function switchToProduct(productHandle, colorName) {
    // console.log('Switching to product:', productHandle, 'Color:', colorName);

    showSkeletonLoaders();

    try {
      const productData = await fetchProductData(productHandle);
      if (!productData) {
        console.error('Failed to load product data');
        const mainImages = document.querySelectorAll('.pdp-main-img');
        mainImages.forEach(img => {
          img.style.opacity = '1';
        });
        return;
      }

      // console.log('Product data loaded:', productData);
      // console.log('Images:', productData.images?.length);

      // Update dynamic options (size, storage, headboard)
      updateDynamicOptions(productData);

      let loadedImagesCount = 0;
      const totalImages = productData.images?.length || 0;
      const mainImages = document.querySelectorAll('.pdp-main-img');

      function checkAllImagesLoaded() {
        loadedImagesCount++;
        if (loadedImagesCount >= totalImages) {
          setTimeout(() => {
            hideSkeletonLoaders();
          }, 100);
        }
      }

      if (productData.images && productData.images.length > 0) {
        mainImages.forEach((img, index) => {
          if (productData.images[index]) {
            const imageUrl = productData.images[index];
            img.src = imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_582x.$1');
            img.srcset = `${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_362x.$1')} 362w, ${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_474x.$1')} 474w, ${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_582x.$1')} 582w, ${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_1164x.$1')} 1164w`;
            img.alt = `${productData.title} - Image ${index + 1}`;
            // Clear any stale lazy-load attributes so Splide won't restore old images
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
            img.removeAttribute('data-sizes');
            img.dataset.loaded = '1';
            img.classList.add('loaded');
            const wrapper = img.closest('.pdp-img-loader-wrapper');
            if (wrapper) wrapper.classList.add('loaded');

            img.onload = function () {
              this.style.opacity = '1';
              checkAllImagesLoaded();
            };

            img.onerror = function () {
              console.error('Failed to load image:', imageUrl);
              checkAllImagesLoaded();
            };
          }
        });

        const thumbnailImages = document.querySelectorAll('.pdp-thumbnail-img');
        thumbnailImages.forEach((thumb, index) => {
          if (productData.images[index]) {
            const imageUrl = productData.images[index];
            thumb.src = imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_180x.$1');
            thumb.srcset = `${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_90x.$1')} 1x, ${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_180x.$1')} 2x`;
            thumb.alt = `${productData.title} - Thumbnail ${index + 1}`;
            thumb.classList.add('loaded');
            const wrapper = thumb.closest('.pdp-thumbnail-loader-wrapper');
            if (wrapper) wrapper.classList.add('loaded');
          }
        });

        const lightboxImages = document.querySelectorAll('.pdp-lightbox-image');
        lightboxImages.forEach((img, index) => {
          if (productData.images[index]) {
            const imageUrl = productData.images[index];
            const lbSrc = imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_1440x.$1');
            const lbSrcset = `${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_800x.$1')} 800w, ${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_1200x.$1')} 1200w, ${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_1440x.$1')} 1440w, ${imageUrl.replace(/\.(jpg|jpeg|png|webp)/, '_2000x.$1')} 2000w`;
            img.src = lbSrc;
            img.srcset = lbSrcset;
            img.setAttribute('data-src', lbSrc);
            img.setAttribute('data-srcset', lbSrcset);
            img.alt = `${productData.title} - Image ${index + 1}`;
          }
        });
      } else {
        hideSkeletonLoaders();
      }

      document.querySelectorAll('#productColorName').forEach((el) => {
        el.textContent = colorName;
      });

      // Keep both desktop/mobile colour labels in sync.
      const mobileColorName = document.getElementById('mobileColorName');
      if (mobileColorName) mobileColorName.textContent = colorName;

      // IMPORTANT: many option handlers read data-current-handle; keep it updated.
      try {
        document.querySelectorAll('#colorProductsGrid, .mbl-clr-variant-wrapper').forEach((el) => {
          el.setAttribute('data-current-handle', productHandle);
          if (colorName) el.setAttribute('data-current-color', colorName);
          try {
            const img = (document.querySelector('.pdp-main-img') || document.querySelector('.pdp-thumbnail-img'));
            if (img && img.getAttribute && img.getAttribute('src')) {
              el.setAttribute('data-current-image', img.getAttribute('src'));
            }
          } catch (_e2) { }
        });
      } catch (_e) { }

      if (productData.price && window.pdpPricing) {
        const basePrice = productData.price / 100;
        if (window.pdpPricing.basePrice !== undefined) {
          window.pdpPricing.basePrice = basePrice;
          updatePricing();
        }
      }

      // Set the product path; variant param will be applied by syncSelectedVariantUI.
      const url = new URL(window.location.href);
      url.pathname = `/products/${productHandle}`;
      url.searchParams.delete('variant');
      window.history.pushState({ productHandle }, '', url.toString());
      window.pdpState.currentProductHandle = productHandle;

      // console.log('Product switched successfully to:', productHandle);
    } finally {
      // ensure loaders always clear even on early return
      hideSkeletonLoaders();
    }
  }

  // Fetch color products from Shopify Storefront API
  async function fetchColorProducts() {
    try {
      const colorGrids = document.querySelectorAll('#colorProductsGrid, .mbl-clr-variant-wrapper');
      // console.log('fetchColorProducts called, found grids:', colorGrids.length);

      if (colorGrids.length === 0) {
        return;
      }

      // Show skeleton placeholders while we fetch
      colorGrids.forEach((grid) => renderColorSkeleton(grid));

      const firstGrid = colorGrids[0];
      const productTitle = firstGrid.getAttribute('data-product-title');
      const currentHandle = firstGrid.getAttribute('data-current-handle');
      const currentImage = firstGrid.getAttribute('data-current-image');
      const currentColor = firstGrid.getAttribute('data-current-color');

      // console.log('Grid attributes:', { productTitle, currentHandle, currentImage, currentColor });

      const collectionHandle = productTitle ? productTitle.toLowerCase().replace(/ /g, '-') : '';

      if (!collectionHandle) {
        console.error('No collection handle found from product title:', productTitle);
        colorGrids.forEach(grid => renderFallback(grid, currentHandle, currentImage, currentColor));
        return;
      }

      // console.log('Fetching colors for:', productTitle, 'Collection:', collectionHandle);
      window.pdpState.currentProductHandle = currentHandle;

      const query = `
      query getCollectionProducts($handle: String!) {
        collection(handle: $handle) {
          handle
          title
          products(first: 50) {
            edges {
              node {
                handle
                title
                featuredImage {
                  url(transform: { maxWidth: 160 })
                  altText
                }
                metafields(identifiers: [
                  { namespace: "options", key: "product_color" }
                ]) {
                  namespace
                  key
                  type
                  value
                  reference {
                    ... on Metaobject {
                      handle
                      fields {
                        key
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

      try {
        const response = await fetch(`${SHOP_URL}/api/${API_VERSION}/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN
          },
          body: JSON.stringify({
            query: query,
            variables: { handle: collectionHandle }
          })
        });

        const result = await response.json();
        // console.log('GraphQL Response:', result);

        if (result.errors) {
          console.error('GraphQL Errors:', result.errors);
          colorGrids.forEach(grid => renderFallback(grid, currentHandle, currentImage, currentColor));
          return;
        }

        if (!result.data || !result.data.collection || !result.data.collection.products) {
          console.warn('No collection found:', collectionHandle, 'Response:', result);
          colorGrids.forEach(grid => renderFallback(grid, currentHandle, currentImage, currentColor));
          return;
        }

        const products = result.data.collection.products.edges.map(edge => edge.node);
        // console.log('Fetched color products:', products.length);

        if (products.length === 0) {
          console.warn('No products in collection');
          colorGrids.forEach(grid => renderFallback(grid, currentHandle, currentImage, currentColor));
          return;
        }

        // console.log('Rendering products to', colorGrids.length, 'grids');
        colorGrids.forEach(grid => {
          renderColorProducts(grid, products, currentHandle);
        });
      } catch (error) {
        console.error('Error fetching colors:', error);
        colorGrids.forEach(grid => renderFallback(grid, currentHandle, currentImage, currentColor));
      }
    } finally {
      // renderColorProducts/renderFallback will replace skeletons
    }
  }

  // Render color products
  function renderColorProducts(grid, products, currentHandle) {
    // console.log('renderColorProducts:', grid?.id || grid?.className, products.length);
    if (!grid) return;

    grid.innerHTML = '';

    products.forEach((product) => {
      const colorMetafield = product.metafields.find(mf => mf.key === 'product_color');
      let colorName = product.title;

      if (colorMetafield && colorMetafield.reference && colorMetafield.reference.fields) {
        const nameField = colorMetafield.reference.fields.find(f => f.key === 'name');
        if (nameField) colorName = nameField.value;
      }

      const isSelected = product.handle === currentHandle;
      const imageUrl = product.featuredImage?.url || '';
      const isMobileGrid = grid.classList.contains('mbl-clr-variant-wrapper');

      const li = document.createElement('li');
      li.className = isMobileGrid ? 'mbl-clr-variant-item shrink-0' : '';

      if (isMobileGrid) {
        li.innerHTML = `
          <div class="bed-item rounded-md ${isSelected ? 'selected' : ''}" 
               data-color="${product.handle}" 
               data-product-handle="${product.handle}"
               data-color-name="${colorName}">
            <img height="92" width="92" class="bed-image w-full" src="${imageUrl.includes('?') ? imageUrl + '&width=92' : imageUrl + '?width=92'}" alt="${colorName}" loading="lazy">
            <div class="bed-name flex justify-center text-center fw-regular text-gray text-center">${colorName}</div>
          </div>
        `;
      } else {
        li.className = `bed-item rounded-md ${isSelected ? 'selected' : ''}`;
        li.setAttribute('data-color', product.handle);
        li.setAttribute('data-product-handle', product.handle);
        li.setAttribute('data-color-name', colorName);
        li.innerHTML = `
          <img height="92" width="92" class="bed-image w-full" src="${imageUrl.includes('?') ? imageUrl + '&width=92' : imageUrl + '?width=92'}" alt="${colorName}" loading="lazy">
          <div class="bed-name flex justify-center text-center fw-regular text-gray text-center">${colorName}</div>
        `;
      }

      grid.appendChild(li);

      if (isSelected) {
        window.pdpState.colour = colorName;
        document.querySelectorAll('[data-filter="colour"] .filter-value').forEach(el => {
          el.textContent = colorName;
        });
        const mobileColorName = document.getElementById('mobileColorName');
        if (mobileColorName) mobileColorName.textContent = colorName;
      }
    });

    // console.log('Grid now has', grid.children.length, 'items');
    attachColorHandlers();
  }

  // Render fallback
  function renderFallback(grid, currentHandle, currentImage, currentColor) {
    // console.log('Rendering fallback');
    const isMobileGrid = grid.classList.contains('mbl-clr-variant-wrapper');

    if (isMobileGrid) {
      grid.innerHTML = `
        <li class="mbl-clr-variant-item">
          <div class="bed-item rounded-md selected" data-color="${currentHandle}" data-product-handle="${currentHandle}" data-color-name="${currentColor}">
            <img height="92" width="92" class="bed-image w-full" src="${currentImage.includes('?') ? currentImage + '&width=92' : currentImage + '?width=92'}" alt="${currentColor}" loading="lazy">
            <div class="bed-name flex justify-center text-center fw-regular text-gray text-center">${currentColor}</div>
          </div>
        </li>
      `;
    } else {
      grid.innerHTML = `
        <li class="bed-item rounded-md selected" data-color="${currentHandle}" data-product-handle="${currentHandle}" data-color-name="${currentColor}">
          <img height="92" width="92" class="bed-image w-full" src="${currentImage.includes('?') ? currentImage + '&width=92' : currentImage + '?width=92'}" alt="${currentColor}" loading="lazy">
          <div class="bed-name flex justify-center text-center fw-regular text-gray text-center">${currentColor}</div>
        </li>
      `;
    }

    window.pdpState.colour = currentColor;
    document.querySelectorAll('[data-filter="colour"] .filter-value').forEach(el => {
      el.textContent = currentColor;
    });

    attachColorHandlers();
  }

  // Attach color click handlers
  function attachColorHandlers() {
    document.querySelectorAll('[data-color]').forEach(item => {
      item.addEventListener('click', async (e) => {
        e.preventDefault();

        document.querySelectorAll('[data-color]').forEach(c => c.classList.remove('selected'));
        document.querySelectorAll(`[data-color="${item.getAttribute('data-color')}"]`).forEach(c => c.classList.add('selected'));

        const colorName = item.getAttribute('data-color-name') || item.querySelector('.bed-name')?.textContent || '';
        const colorSlug = item.getAttribute('data-color');
        const productHandle = item.getAttribute('data-product-handle') || colorSlug;

        window.pdpState.colour = colorName;
        window.pdpState.colourSlug = colorSlug;

        document.querySelectorAll('[data-filter="colour"] .filter-value').forEach(el => {
          el.textContent = colorName;
        });

        document.querySelectorAll('#productColorName').forEach((el) => {
          el.textContent = colorName;
        });

        const mobileColorName = document.getElementById('mobileColorName');
        if (mobileColorName) mobileColorName.textContent = colorName;

        // Keep data-current-handle in sync even before async switch completes.
        try {
          document.querySelectorAll('#colorProductsGrid, .mbl-clr-variant-wrapper').forEach((el) => {
            el.setAttribute('data-current-handle', productHandle);
            if (colorName) el.setAttribute('data-current-color', colorName);
          });
        } catch (_e) { }

        // console.log('Color changed:', colorName, 'Handle:', productHandle);

        if (productHandle && productHandle !== window.pdpState.currentProductHandle) {
          await switchToProduct(productHandle, colorName);
        }
      });
    });
  }

  let variantSelectorInitialized = false;
  function initVariantSelector() {
    // Prevent multiple initializations that would attach duplicate event listeners
    if (variantSelectorInitialized) {
      // console.log('⏭️ Variant selector already initialized, skipping...');
      return;
    }

    const variantContainers = document.querySelectorAll('.pdp-variant');
    // console.log('Found variant containers:', variantContainers.length);

    variantContainers.forEach((container) => {
      const filterItems = container.querySelectorAll('.filter-item');
      const sections = {
        colour: container.querySelector('#colourSection'),
        size: container.querySelector('#sizeSection'),
        storage: container.querySelector('#storageSection'),
        headboard: container.querySelector('#headboardSection'),
        base: container.querySelector('#baseSection')
      };

      filterItems.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const filter = item.getAttribute('data-filter');

          filterItems.forEach((f) => f.classList.remove('active'));
          item.classList.add('active');

          Object.keys(sections).forEach((key) => {
            if (sections[key]) sections[key].classList.add('hidden');
          });

          if (sections[filter]) sections[filter].classList.remove('hidden');
        });
      });

      // On narrow mobile, remove Colour entirely and default to Size view
      if (isNoColourMobile()) {
        const colourItem = container.querySelector('[data-filter="colour"]');
        if (colourItem) colourItem.classList.add('filter-hidden');
        if (sections.colour) sections.colour.classList.add('hidden');

        const sizeItem = container.querySelector('[data-filter="size"]');
        if (sizeItem) {
          filterItems.forEach((f) => f.classList.remove('active'));
          sizeItem.classList.add('active');
          Object.keys(sections).forEach((key) => {
            if (sections[key]) sections[key].classList.add('hidden');
          });
          if (sections.size) sections.size.classList.remove('hidden');
        }
      }

      function updateFilterValues(filterType, value) {
        document.querySelectorAll(`[data-filter="${filterType}"] .filter-value`).forEach((el) => {
          el.textContent = value;
        });
      }

      const sizeItems = container.querySelectorAll('[data-size]');
      sizeItems.forEach((item) => {
        item.addEventListener('click', async () => {
          document.querySelectorAll('[data-size]').forEach((s) => s.classList.remove('selected'));
          document.querySelectorAll(`[data-size="${item.getAttribute('data-size')}"]`).forEach((s) => s.classList.add('selected'));

          const sizeName = item.querySelector('.option-name').textContent.trim();

          window.pdpState.size = sizeName;
          updateFilterValues('size', sizeName);
          try {
            window.dispatchEvent(new CustomEvent('sonno:pdpStateChanged', { detail: { ...(window.pdpState || {}) } }));
          } catch (_e) { }

          // console.log('🔄 Size changed to:', sizeName, '- Updating storage and headboard options...');

          // Update storage and headboard options based on new size
          const currentHandle = getCurrentHandle();
          if (currentHandle) {
            const productData = await fetchProductData(currentHandle);
            if (productData) {
              // Call updateDynamicOptions to filter storage and headboard
              await updateDynamicOptions(productData);
            }
          }

          updatePricing();
        });
      });

      const storageItems = container.querySelectorAll('[data-storage]');
      storageItems.forEach((item) => {
        item.addEventListener('click', async () => {
          document.querySelectorAll('[data-storage]').forEach((s) => s.classList.remove('selected'));
          document.querySelectorAll(`[data-storage="${item.getAttribute('data-storage')}"]`).forEach((s) => s.classList.add('selected'));

          const storageName = item.querySelector('.option-name').textContent.trim();

          window.pdpState.storage = storageName;
          updateFilterValues('storage', storageName);

          // console.log('🔄 Storage changed to:', storageName, '- Updating headboard options...');

          // Update headboard options based on new size+storage combination
          const currentHandle = getCurrentHandle();
          if (currentHandle) {
            const productData = await fetchProductData(currentHandle);
            if (productData) {
              // Call updateDynamicOptions to filter headboard
              await updateDynamicOptions(productData);
            }
          }

          updatePricing();
        });
      });

      const headboardItems = container.querySelectorAll('[data-headboard]');
      headboardItems.forEach((item) => {
        item.addEventListener('click', async () => {
          document.querySelectorAll('[data-headboard]').forEach((h) => h.classList.remove('selected'));
          document.querySelectorAll(`[data-headboard="${item.getAttribute('data-headboard')}"]`).forEach((h) => h.classList.add('selected'));

          const headboardName = item.querySelector('.option-name').textContent.trim();

          window.pdpState.headboard = headboardName;
          setHeadboardFilterText(headboardName);
          try {
            window.dispatchEvent(new CustomEvent('sonno:pdpStateChanged', { detail: { ...(window.pdpState || {}) } }));
          } catch (_e) { }

          // console.log('🔄 Headboard changed to:', headboardName, '- Updating prices...');

          // Update headboard prices based on new selection
          const currentHandle = getCurrentHandle();
          if (currentHandle) {
            const productData = await fetchProductData(currentHandle);
            if (productData) {
              // Call updateDynamicOptions to recalculate prices
              await updateDynamicOptions(productData);
            }
          }

          updatePricing();
        });
      });

      const headboardButtonItems = container.querySelectorAll('[data-headboard-button]');
      if (headboardButtonItems && headboardButtonItems.length > 0) {
        const getButtonNameFromItem = (el) => {
          return (
            el.getAttribute('data-headboard-button') ||
            el.querySelector('.option-name')?.textContent?.trim() ||
            ''
          );
        };

        const syncHeadboardButtonSelectedUI = () => {
          const selected = normalizeText(window.pdpState?.headboardButton);
          document.querySelectorAll('[data-headboard-button]').forEach((el) => {
            const name = normalizeText(getButtonNameFromItem(el));
            if (selected && name === selected) el.classList.add('selected');
            else el.classList.remove('selected');
          });
        };

        // Initialize default selection if missing
        if (!normalizeText(window.pdpState?.headboardButton)) {
          const firstName = getButtonNameFromItem(headboardButtonItems[0]);
          window.pdpState.headboardButton = firstName;
          setHeadboardFilterText(window.pdpState?.headboard);
          try {
            window.dispatchEvent(new CustomEvent('sonno:pdpStateChanged', { detail: { ...(window.pdpState || {}) } }));
          } catch (_e) { }
        }
        syncHeadboardButtonSelectedUI();

        headboardButtonItems.forEach((item) => {
          item.addEventListener('click', () => {
            const buttonName = getButtonNameFromItem(item);
            window.pdpState.headboardButton = buttonName;

            syncHeadboardButtonSelectedUI();
            setHeadboardFilterText(window.pdpState?.headboard);
            try {
              window.dispatchEvent(new CustomEvent('sonno:pdpStateChanged', { detail: { ...(window.pdpState || {}) } }));
            } catch (_e) { }
          });
        });
      }

      const baseItems = container.querySelectorAll('[data-base]');
      baseItems.forEach((item) => {
        if (item.getAttribute('data-base-bound') === '1') return;
        item.setAttribute('data-base-bound', '1');
        item.addEventListener('click', () => updateBaseSelectionFromItem(item));
      });
    });

    variantSelectorInitialized = true;
    // console.log('✅ Variant selector initialized');
  }

  window.addEventListener('popstate', (event) => {
    if (event.state && event.state.productHandle) {
      window.location.reload();
    }
  });

  // Initialize dynamic options on page load
  async function initializePage() {
    try {
      initMattressVariantSelector();

      const currentHandle = getCurrentHandle();
      if (currentHandle) {
        const productData = await fetchProductData(currentHandle);
        if (productData) {
          updateDynamicOptions(productData);
        }
      }

      await fetchColorProducts();
      initVariantSelector();
    } finally {
      // Mark PDP filter bar as ready (show real labels/values)
      try {
        document.querySelectorAll('.pdp-variant[data-sonno-pdp-init="1"]').forEach((el) => {
          el.setAttribute('data-sonno-pdp-init', '0');
        });
      } catch (_e) { }

      // Recompute columns now that init skeleton is gone
      setTimeout(() => {
        try { updateFilterBarGrid(); } catch (_e) { }
      }, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage);
  } else {
    initializePage();
  }
})();

function initMattressVariantSelector() {
  try {
    const containers = document.querySelectorAll('[data-sonno-mattress-variant]');
    if (!containers || containers.length === 0) return;

    const readUrlVariantId = () => {
      try {
        const url = new URL(window.location.href);
        const raw = url.searchParams.get('variant');
        const n = parseInt(raw || '', 10);
        return Number.isFinite(n) ? n : null;
      } catch (_e) {
        return null;
      }
    };

    const updateUrlVariantId = (variantId) => {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variantId));
        window.history.replaceState({ variantId }, '', url.toString());
      } catch (_e) {
        // ignore
      }
    };

    const normalize = (v) => String(v || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

    const setAllText = (selector, value) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.textContent = value;
      });
    };

    const setSelectedByVariantId = (variantId) => {
      document.querySelectorAll('[data-sonno-mattress-variant] [data-variant-id]').forEach((li) => {
        const id = parseInt(li.getAttribute('data-variant-id') || '', 10);
        if (id === variantId) li.classList.add('selected');
        else li.classList.remove('selected');
      });
    };

    const updateDimsFromVariantId = (variantId) => {
      const selected = document.querySelector(`[data-sonno-mattress-variant] [data-variant-id="${variantId}"]`);
      if (!selected) return;
      setAllText('[data-sonno-mattress-width]', normalize(selected.getAttribute('data-width')));
      setAllText('[data-sonno-mattress-length]', normalize(selected.getAttribute('data-length')));
    };

    const formatMoneyDiff = (diffCents) => {
      const n = Number(diffCents || 0) / 100;
      if (!Number.isFinite(n) || n === 0) return '';
      const sign = n > 0 ? '+' : (n < 0 ? '-' : '');
      return `${sign}£${Math.abs(n).toFixed(2)}`;
    };

    const updatePriceDiffs = (selectedVariantId) => {
      const selected = document.querySelector(`[data-sonno-mattress-variant] [data-variant-id="${selectedVariantId}"]`);
      if (!selected) return;
      const selectedPrice = parseInt(selected.getAttribute('data-price-cents') || '0', 10) || 0;

      document.querySelectorAll('[data-sonno-mattress-variant] [data-variant-id]').forEach((li) => {
        const price = parseInt(li.getAttribute('data-price-cents') || '0', 10) || 0;
        const diff = price - selectedPrice;
        const el = li.querySelector('[data-sonno-mattress-size-price-diff]');
        if (!el) return;
        const text = formatMoneyDiff(diff);
        el.textContent = text;
        el.style.display = text ? 'block' : 'none';
      });
    };

    const updateStateFromVariantId = (variantId) => {
      const selected = document.querySelector(`[data-sonno-mattress-variant] [data-variant-id="${variantId}"]`);
      if (!selected) return;

      const sizeName = selected.querySelector('.option-name')?.textContent?.trim() || '';
      const price = parseInt(selected.getAttribute('data-price-cents') || '0', 10) || 0;
      const compareAtPrice = parseInt(selected.getAttribute('data-compare-at-price-cents') || '0', 10) || 0;

      window.pdpState = window.pdpState || {};
      window.pdpState.size = sizeName;
      window.pdpState.storage = window.pdpState.storage || 'No Storage';
      window.pdpState.headboard = window.pdpState.headboard || 'No Headboard';
      window.pdpState._lastVariant = {
        id: variantId,
        price,
        compare_at_price: compareAtPrice,
        option1: sizeName
      };

      try {
        window.dispatchEvent(new CustomEvent('sonno:pdpStateChanged', { detail: { ...(window.pdpState || {}) } }));
      } catch (_e) { }

      try {
        if (window.pdpPricing && typeof window.pdpPricing.updatePrice === 'function') {
          window.pdpPricing.updatePrice();
        }
      } catch (_e) { }
    };

    const bindClicks = () => {
      document.querySelectorAll('[data-sonno-mattress-variant] [data-variant-id]').forEach((li) => {
        if (li.getAttribute('data-sonno-bound') === '1') return;
        li.setAttribute('data-sonno-bound', '1');

        li.addEventListener('click', () => {
          if (li.getAttribute('aria-disabled') === 'true') return;
          const variantId = parseInt(li.getAttribute('data-variant-id') || '', 10);
          if (!Number.isFinite(variantId)) return;
          const sizeName = li.querySelector('.option-name')?.textContent?.trim() || '';

          setSelectedByVariantId(variantId);
          setAllText('[data-sonno-mattress-size-label]', sizeName);
          updateDimsFromVariantId(variantId);
          updatePriceDiffs(variantId);
          updateUrlVariantId(variantId);
          updateStateFromVariantId(variantId);
        });
      });
    };

    bindClicks();

    const urlVariantId = readUrlVariantId();
    const initialAttr = parseInt(containers[0].getAttribute('data-initial-variant-id') || '', 10);
    const initialVariantId = urlVariantId || (Number.isFinite(initialAttr) ? initialAttr : null);
    if (!initialVariantId) return;

    const initialEl = document.querySelector(`[data-sonno-mattress-variant] [data-variant-id="${initialVariantId}"]`);
    if (initialEl) {
      const sizeName = initialEl.querySelector('.option-name')?.textContent?.trim() || '';
      setSelectedByVariantId(initialVariantId);
      setAllText('[data-sonno-mattress-size-label]', sizeName);
      updateDimsFromVariantId(initialVariantId);
      updatePriceDiffs(initialVariantId);
      updateStateFromVariantId(initialVariantId);
      updateUrlVariantId(initialVariantId);
    }
  } catch (_e) {
    // ignore
  }
}
